import { default as module } from './AbstractModule';
import { $document } from '../utils/environment'
import { EVENT as SCROLL_EVENT } from '../scroll/Scroll'

export default class extends module {
    constructor(m) {
        super(m);

        this.limit = this.$('limit')
        this.inner = this.$('inner')

        this.onVisibilityChangeBind = (e) => {
            if(e.target != this.el) return

            requestAnimationFrame(() => {
                if(!this.active && e.way == 'enter') {
                    this.compute()
                    this.active = true
                    this.scrollUpdate()
                } else if(this.active && e.way == 'leave') {
                    cancelAnimationFrame(this.raf)
                    this.active = false
                }
            })
        }
        $document.on('visibility.Footer', this.onVisibilityChangeBind)

        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)

        this.scrollUpdateBind = this.scrollUpdate.bind(this)
        $document.on(SCROLL_EVENT.SCROLLING, this.scrollUpdateBind)
    }

    init() {
        this.compute()
    }

    checkResize() {
        if(!this.resizeTick) {
            requestAnimationFrame(() => {
                this.compute();
                this.resizeTick = false
            });
            this.resizeTick = true;
        }
    }

    compute() {
        this.hasSmoothScroll = false
        if(document.documentElement.classList.contains('has-smooth-scroll'))
            this.hasSmoothScroll = true

        // Make sure to reset initial state before computing data
        TweenMax.set(this.inner, { y: 0 })

        // SCROLL RELATED
        this.BCR = this.el.getBoundingClientRect()
        this.limitBCR = this.limit.getBoundingClientRect()
        let compensation = this.hasSmoothScroll ? window.app.scroll.y : (document.scrollingElement ? document.scrollingElement.scrollTop : document.documentElement.scrollTop)
        this.offsetTop = this.BCR.top + compensation;
        this.offsetLimit = this.limitBCR.top + compensation;
        this.offsetDiff = this.offsetLimit - this.offsetTop
        this.scrollStart = this.offsetTop - window.innerHeight;
        this.scrollEnd = this.offsetLimit - window.innerHeight;
    }

    scrollUpdate() {
        if(!this.active) return;

        if(this.offsetTop - window.app.scroll.y < 100) document.documentElement.classList.add('is-over-footer')
        else document.documentElement.classList.remove('is-over-footer')

        if(window.app.scroll.y > this.scrollStart && window.app.scroll.y < this.scrollEnd) {
            TweenMax.set(this.inner, { y: -this.offsetDiff + (window.app.scroll.y - this.scrollStart) })
        } else {
            TweenMax.set(this.inner, { y: 0 })
        }
    }

    destroy() {
        window.removeEventListener('resize', this.checkResizeBind)
        $document.off(SCROLL_EVENT.SCROLLING, this.scrollUpdateBind)
    }
}
